// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("core.ruffle." + {"110":"bc3d08e86fcbbd39a295","993":"84a67f58f14b63f10116"}[chunkId] + ".js");